import './SuccessContent.scss';
import './SuccessContent-media.scss';
import { LinkTg, LinkVk } from '../../services/content/Constants';
import { SvgTg, SvgVk } from '../Header/MenuPopupTeam/constants';
import {content} from "../../services/content";

const SuccessContent = ({ refCss, socs = false }: { refCss?: any; socs?: boolean }) => {
  return (
    <div ref={refCss} className="success-content">
      <h2 className="success-content__text">{content.modalForm.successText}</h2>
      <p className="body1">{content.modalForm.successText2}</p>
      {socs && (
        <div className="success-content__socs">
          <a href={LinkTg} target="_blank" className="success-content__soc" rel="nofollow">
            {SvgTg}
          </a>
          <a href={LinkVk} className="success-content__soc" target="_blank" rel="nofollow">
            {SvgVk}
          </a>
        </div>
      )}
    </div>
  );
};

export default SuccessContent;
